import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Navigation.scss';
import { HamburgerButton } from './../../ui/Button/HamburgerButton';
import { FacebookIcon } from './../../ui/Icons/FacebookIcon';
import { InstagramIcon } from './../../ui/Icons/InstagramIcon';

const navLinks = [
  { label: 'Sobre Nós', to: '/sobre', match: '/sobre' },
  { label: 'Ferramentas', to: '/ferramentas', match: '/ferramentas' },
];

const socialLinks = [
  {
    icon: <FacebookIcon />,
    to: 'https://www.facebook.com/PloverDigitalSolutions/',
    label: 'Seguir a Plover no Facebook, abre num novo separador',
  },
  {
    icon: <InstagramIcon />,
    to: 'https://www.instagram.com/plover.digital.solutions/',
    label: 'Seguir a Plover no Instagram, abre num novo separador',
  },
];

function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleHamburgerClick = () => {
    setDrawerOpen((prevState) => !prevState);
    setHamburgerMenuOpen((prevState) => !prevState);
  };

  const handleMenuLinks = () => {
    setDrawerOpen(false);
    setHamburgerMenuOpen(false);
  };

  const handleMenuHomepageLinks = () => {
    if (hamburgerMenuOpen) {
      setDrawerOpen(false);
      setHamburgerMenuOpen(false);
    }
  };

  const handleClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };

  useEffect(() => {
    if (drawerOpen) {
      document.body.classList.add('scroll-lock');
    } else {
      document.body.classList.remove('scroll-lock');
    }
    return () => document.body.classList.remove('scroll-lock');
  }, [drawerOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          to="/"
          target="_self"
          className="navbar-logo"
          onClick={handleMenuHomepageLinks}
        >
          <img
            src="/images/media/logo.svg"
            alt="Plover Homepage"
            className="navbar-logo-img"
          />
        </Link>

        <div className="navbar-links desktop">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className={`navbar-link ${
                location.pathname.startsWith(link.match) ? 'active' : ''
              }`}
            >
              {link.label}
            </Link>
          ))}
          <button onClick={handleClick} className="navbar-link cta-filled">
            Fale Connosco
          </button>
        </div>

        <div className="navbar-hb" onClick={handleHamburgerClick}>
          <HamburgerButton isOpen={hamburgerMenuOpen} />
        </div>
      </div>

      <div
        className={`navbar-mobile-drawer-wrapper ${
          drawerOpen ? 'open' : ''
        }`}
      >
        {drawerOpen && (
          <div className="navbar-mobile-drawer">
            {navLinks.map((link, index) => (
              <Link key={index} to={link.to} onClick={handleMenuLinks}>
                {link.label}
              </Link>
            ))}
            <div className="social-bottom-links">
              {socialLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  onClick={handleMenuLinks}
                >
                  {link.icon}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;